var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 472,
    height: 274,
    viewBox: "0 0 472 274",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50_521)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 472,
    height: 274,
    fill: "#FFDAE3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.333 137C189.333 111.24 210.24 90.333 236 90.333C261.76 90.333 282.667 111.24 282.667 137C282.667 162.76 261.76 183.666 236 183.666C210.24 183.666 189.333 162.76 189.333 137ZM230.4 118.8C228.86 117.633 226.667 118.753 226.667 120.666V153.333C226.667 155.246 228.86 156.366 230.4 155.2L252.193 138.866C253.453 137.933 253.453 136.066 252.193 135.133L230.4 118.8Z",
    fill: "#E75074"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 472,
    height: 274,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.927291745ba4f8c968e4347fd2605dc5.svg";
export { ForwardRef as ReactComponent };